import React, { useState } from 'react';

const MDeRCMMentalComponent = () => {
  // Custom SVG Icons as components
  const ChevronDown = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="6,9 12,15 18,9"></polyline>
    </svg>
  );

  const ChevronRight = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9,18 15,12 9,6"></polyline>
    </svg>
  );

  const AlertTriangle = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );

  const CheckCircle = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );

  const Brain = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/>
      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/>
      <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"/>
      <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"/>
      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"/>
      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"/>
      <path d="M19.938 10.5a4 4 0 0 1 .585.396"/>
      <path d="M6 18a4 4 0 0 1-1.967-.516"/>
      <path d="M19.967 17.484A4 4 0 0 1 18 18"/>
    </svg>
  );

  const Document = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  );

  const Shield = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );

  const Clock = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12 6 12 12 16 14"/>
    </svg>
  );

  const [activeTab, setActiveTab] = useState('problems');
  const [expandedProblem, setExpandedProblem] = useState(null);
  const [expandedSolution, setExpandedSolution] = useState(null);

  // Styles (same as dental component)
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(to bottom right, #f0fdf4, #ffffff, #ecfdf5)',
      fontFamily: 'Arial, sans-serif'
    },
    header: {
      background: 'linear-gradient(to right, #8b5cf6, #6366f1)',
      color: 'white',
      padding: '2rem 0'
    },
    headerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1.5rem',
      textAlign: 'center'
    },
    mainTitle: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#c4b5fd',
      marginBottom: '1rem'
    },
    description: {
      color: '#a5b4fc',
      maxWidth: '48rem',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    tabNavigation: {
      background: 'white',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      borderBottom: '1px solid #e5e7eb'
    },
    tabContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1.5rem',
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem'
    },
    tabButton: (active) => ({
      padding: '1rem 0.5rem',
      borderBottom: active ? '2px solid #8b5cf6' : '2px solid transparent',
      color: active ? '#8b5cf6' : '#6b7280',
      fontWeight: '500',
      fontSize: '0.875rem',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }),
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '3rem 1.5rem'
    },
    sectionHeader: {
      textAlign: 'center',
      marginBottom: '3rem'
    },
    sectionTitle: {
      fontSize: '2rem',
      fontWeight: 'bold',
      color: '#111827',
      marginBottom: '1rem'
    },
    sectionSubtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '48rem',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    problemsGrid: {
      display: 'grid',
      gap: '1.5rem',
      maxWidth: '64rem',
      margin: '0 auto'
    },
    solutionsGrid: {
      display: 'grid',
      gap: '2rem',
      maxWidth: '72rem',
      margin: '0 auto'
    },
    card: {
      background: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden'
    },
    solutionCard: {
      background: 'white',
      borderRadius: '0.75rem',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      transition: 'box-shadow 0.3s'
    },
    cardHeader: {
      padding: '1.5rem',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    cardHeaderHover: {
      backgroundColor: '#f9fafb'
    },
    cardContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    cardLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    iconContainer: (severity) => ({
      padding: '0.5rem',
      borderRadius: '0.5rem',
      backgroundColor: severity === 'high' ? '#fee2e2' : '#fef3c7'
    }),
    icon: (severity) => ({
      width: '1.25rem',
      height: '1.25rem',
      color: severity === 'high' ? '#dc2626' : '#d97706'
    }),
    cardInfo: {
      flex: 1
    },
    cardTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '0.25rem'
    },
    cardDescription: {
      color: '#6b7280'
    },
    cardRight: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    impactBadge: (severity) => ({
      fontSize: '0.875rem',
      fontWeight: '500',
      color: severity === 'high' ? '#dc2626' : '#d97706'
    }),
    expandedContent: {
      padding: '0 1.5rem 1.5rem',
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb'
    },
    expandedContentInner: {
      paddingTop: '1rem'
    },
    expandedTitle: {
      fontWeight: '500',
      color: '#111827',
      marginBottom: '0.75rem'
    },
    detailsList: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    detailItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.5rem',
      marginBottom: '0.5rem'
    },
    detailBullet: {
      width: '0.5rem',
      height: '0.5rem',
      backgroundColor: '#9ca3af',
      borderRadius: '50%',
      marginTop: '0.5rem',
      flexShrink: 0
    },
    detailText: {
      color: '#374151'
    },
    solutionCardHeader: {
      padding: '2rem',
      cursor: 'pointer'
    },
    solutionCardContent: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    },
    solutionLeft: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1.5rem'
    },
    solutionIconContainer: {
      backgroundColor: '#ede9fe',
      padding: '0.75rem',
      borderRadius: '0.5rem'
    },
    solutionIcon: {
      color: '#8b5cf6'
    },
    solutionInfo: {
      flex: 1
    },
    solutionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#111827',
      marginBottom: '0.5rem'
    },
    solutionDescription: {
      color: '#6b7280',
      marginBottom: '1rem'
    },
    benefitsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.75rem'
    },
    benefitBadge: {
      backgroundColor: '#ecfdf5',
      color: '#065f46',
      padding: '0.25rem 0.75rem',
      borderRadius: '9999px',
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    chevronContainer: {
      marginLeft: '1rem'
    },
    solutionExpandedContent: {
      padding: '0 2rem 2rem',
      borderTop: '1px solid #e5e7eb',
      background: 'linear-gradient(to right, #f5f3ff, #ede9fe)'
    },
    solutionExpandedInner: {
      paddingTop: '1.5rem'
    },
    featuresTitle: {
      fontWeight: '600',
      color: '#111827',
      marginBottom: '1rem',
      display: 'flex',
      alignItems: 'center'
    },
    checkIcon: {
      width: '1.25rem',
      height: '1.25rem',
      color: '#10b981',
      marginRight: '0.5rem'
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '1rem'
    },
    featureItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem',
      backgroundColor: 'white',
      padding: '1rem',
      borderRadius: '0.5rem'
    },
    featureBullet: {
      width: '0.5rem',
      height: '0.5rem',
      backgroundColor: '#8b5cf6',
      borderRadius: '50%',
      marginTop: '0.5rem',
      flexShrink: 0
    },
    featureText: {
      color: '#374151'
    },
    cta: {
      background: 'linear-gradient(to right, #8b5cf6, #6366f1)',
      color: 'white',
      padding: '4rem 0'
    },
    ctaContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1.5rem',
      textAlign: 'center'
    },
    ctaTitle: {
      fontSize: '2rem',
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    ctaDescription: {
      fontSize: '1.25rem',
      color: '#a5b4fc',
      marginBottom: '2rem',
      maxWidth: '32rem',
      margin: '0 auto 2rem'
    },
    ctaButtons: {
      display: 'flex',
      flexDirection: 'row',
      gap: '1rem',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    ctaButtonPrimary: {
      backgroundColor: 'white',
      color: '#8b5cf6',
      padding: '0.75rem 2rem',
      borderRadius: '0.5rem',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    ctaButtonSecondary: {
      border: '2px solid white',
      color: 'white',
      backgroundColor: 'transparent',
      padding: '0.75rem 2rem',
      borderRadius: '0.5rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }
  };

  const mentalHealthProblems = [
    {
      id: 1,
      title: "Prior Authorization Delays",
      impact: "30-40% Revenue Loss",
      description: "Manual authorization processes delay treatment starts and revenue collection",
      details: [
        "Time-consuming manual submission processes",
        "Incomplete clinical documentation for auth requests",
        "Delays in treatment initiation affecting patient outcomes",
        "Higher claim denial rates due to authorization issues"
      ],
      severity: "high"
    },
    {
      id: 2,
      title: "Session Documentation",
      impact: "20-25% Claim Denials",
      description: "Inadequate session notes lead to insurance claim rejections",
      details: [
        "Missing or incomplete progress notes",
        "Inconsistent DSM coding across sessions",
        "Poor medical necessity documentation",
        "Lack of standardized documentation processes"
      ],
      severity: "high"
    },
    {
      id: 3,
      title: "Patient Responsibility Collections",
      impact: "45% Collection Rate Drop",
      description: "Inefficient collection processes for copays and deductibles",
      details: [
        "Limited payment options for patients",
        "Poor communication about financial responsibility",
        "Delayed billing and follow-up processes",
        "No automated payment reminders for balances"
      ],
      severity: "medium"
    },
    {
      id: 4,
      title: "Utilization Review Management",
      impact: "25% Revenue Leakage",
      description: "Inefficient tracking of authorized sessions leads to lost revenue",
      details: [
        "Manual tracking of authorized sessions",
        "Missed authorization renewal deadlines",
        "Untimely submission of clinical updates",
        "Lack of automated utilization alerts"
      ],
      severity: "medium"
    }
  ];

  const solutions = [
    {
      id: 1,
      title: "AI-Powered Authorization Management",
      icon: <Brain />,
      benefits: ["90% Approval Rate", "75% Time Reduction", "Real-time Tracking"],
      description: "Automated prior authorization submission and tracking for mental health services",
      features: [
        "Automated auth request generation with clinical documentation",
        "Real-time tracking across multiple payers",
        "Smart alerts for upcoming expirations",
        "Integration with EHR and practice management systems"
      ]
    },
    {
      id: 2,
      title: "Intelligent Session Documentation",
      icon: <Document />,
      benefits: ["95% Documentation Quality", "65% Time Savings", "Compliance Assured"],
      description: "AI-assisted progress note generation and DSM coding optimization",
      features: [
        "Auto-generated progress notes from session recordings",
        "Smart DSM coding suggestions based on session content",
        "Medical necessity checking against insurance requirements",
        "Compliance validation before submission"
      ]
    },
    {
      id: 3,
      title: "Patient Financial Management",
      icon: <Clock />,
      benefits: ["80% Collection Rate", "60% Faster Payments", "Improved Patient Experience"],
      description: "Automated patient responsibility collection and payment processing",
      features: [
        "Multiple payment options including sliding scale",
        "Automated payment reminders and statements",
        "Transparent cost estimation before treatment",
        "Secure online payment portal integration"
      ]
    },
    {
      id: 4,
      title: "Utilization Review Automation",
      icon: <Shield />,
      benefits: ["90% Auth Utilization", "85% Process Efficiency", "Seamless Integration"],
      description: "Automated utilization review and authorization management",
      features: [
        "Automated tracking of authorized sessions",
        "Renewal request generation before expiration",
        "Clinical update submission automation",
        "Real-time utilization analytics and alerts"
      ]
    }
  ];

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <p style={styles.subtitle}>Mental Health Revenue Cycle Solutions</p>
          <p style={styles.description}>
            Eliminate administrative burdens with AI-powered automation. Transform your mental health practice's 
            revenue cycle with specialized Generative AI and Large Language Models.
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div style={styles.tabNavigation}>
        <div style={styles.tabContainer}>
          <button
            onClick={() => setActiveTab('problems')}
            style={styles.tabButton(activeTab === 'problems')}
          >
            Current Challenges
          </button>
          <button
            onClick={() => setActiveTab('solutions')}
            style={styles.tabButton(activeTab === 'solutions')}
          >
            AI-Powered Solutions
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={styles.mainContent}>
        {activeTab === 'problems' && (
          <div>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>
                Mental Health Revenue Cycle Challenges
              </h2>
              <p style={styles.sectionSubtitle}>
                Identify and understand the critical bottlenecks affecting your mental health practice's financial performance
              </p>
            </div>

            <div style={styles.problemsGrid}>
              {mentalHealthProblems.map((problem) => (
                <div key={problem.id} style={styles.card}>
                  <div
                    style={{
                      ...styles.cardHeader,
                      ...(expandedProblem === problem.id ? {} : {}),
                    }}
                    onClick={() => setExpandedProblem(expandedProblem === problem.id ? null : problem.id)}
                    onMouseEnter={(e) => {
                      if (expandedProblem !== problem.id) {
                        e.target.style.backgroundColor = styles.cardHeaderHover.backgroundColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (expandedProblem !== problem.id) {
                        e.target.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <div style={styles.cardContent}>
                      <div style={styles.cardLeft}>
                        <div style={styles.iconContainer(problem.severity)}>
                          <div style={styles.icon(problem.severity)}>
                            <AlertTriangle />
                          </div>
                        </div>
                        <div style={styles.cardInfo}>
                          <h3 style={styles.cardTitle}>{problem.title}</h3>
                          <p style={styles.cardDescription}>{problem.description}</p>
                        </div>
                      </div>
                      <div style={styles.cardRight}>
                        <div>
                          <div style={styles.impactBadge(problem.severity)}>
                            {problem.impact}
                          </div>
                        </div>
                        <div style={styles.chevronContainer}>
                          {expandedProblem === problem.id ? (
                            <ChevronDown />
                          ) : (
                            <ChevronRight />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {expandedProblem === problem.id && (
                    <div style={styles.expandedContent}>
                      <div style={styles.expandedContentInner}>
                        <h4 style={styles.expandedTitle}>Key Issues:</h4>
                        <ul style={styles.detailsList}>
                          {problem.details.map((detail, index) => (
                            <li key={index} style={styles.detailItem}>
                              <div style={styles.detailBullet}></div>
                              <span style={styles.detailText}>{detail}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'solutions' && (
          <div>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>
                AI-Powered Mental Health Solutions
              </h2>
              <p style={styles.sectionSubtitle}>
                Transform your mental health practice with specialized automation and seamless system integration
              </p>
            </div>

            <div style={styles.solutionsGrid}>
              {solutions.map((solution) => (
                <div
                  key={solution.id}
                  style={styles.solutionCard}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div
                    style={styles.solutionCardHeader}
                    onClick={() => setExpandedSolution(expandedSolution === solution.id ? null : solution.id)}
                  >
                    <div style={styles.solutionCardContent}>
                      <div style={styles.solutionLeft}>
                        <div style={styles.solutionIconContainer}>
                          <div style={styles.solutionIcon}>
                            {solution.icon}
                          </div>
                        </div>
                        <div style={styles.solutionInfo}>
                          <h3 style={styles.solutionTitle}>{solution.title}</h3>
                          <p style={styles.solutionDescription}>{solution.description}</p>
                          <div style={styles.benefitsContainer}>
                            {solution.benefits.map((benefit, index) => (
                              <span key={index} style={styles.benefitBadge}>
                                {benefit}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div style={styles.chevronContainer}>
                        {expandedSolution === solution.id ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                      </div>
                    </div>
                  </div>

                  {expandedSolution === solution.id && (
                    <div style={styles.solutionExpandedContent}>
                      <div style={styles.solutionExpandedInner}>
                        <h4 style={styles.featuresTitle}>
                          <div style={styles.checkIcon}>
                            <CheckCircle />
                          </div>
                          Key Features:
                        </h4>
                        <div style={styles.featuresGrid}>
                          {solution.features.map((feature, index) => (
                            <div key={index} style={styles.featureItem}>
                              <div style={styles.featureBullet}></div>
                              <span style={styles.featureText}>{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MDeRCMMentalComponent;